import { render } from "./IndependenceView.vue?vue&type=template&id=4828ac50"
import script from "./IndependenceView.vue?vue&type=script&lang=js"
export * from "./IndependenceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__